export const biddata = [
    {
        id: "2RTO782U13",
        categories: "Plumbing",
        subcategories: "Pipe Installation",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        Date: "05/01/2025",
        Time: "Morning 9 to 2",
        location: "123, Street Name, Landmark, City"
    },
    {
        id: "2RTO782U13",
        categories: "Plumbing",
        subcategories: "Pipe Installation",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        Date: "05/01/2025",
        Time: "Morning 9 to 2",
        location: "123, Street Name, Landmark, City"
    },
    {
        id: "2RTO782U13",
        categories: "Plumbing",
        subcategories: "Pipe Installation",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        Date: "05/01/2025",
        Time: "Morning 9 to 2",
        location: "123, Street Name, Landmark, City"
    },
    {
        id: "2RTO782U13",
        categories: "Plumbing",
        subcategories: "Pipe Installation",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        Date: "05/01/2025",
        Time: "Morning 9 to 2",
        location: "123, Street Name, Landmark, City"
    },
    {
        id: "2RTO782U13",
        categories: "Plumbing",
        subcategories: "Pipe Installation",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        Date: "05/01/2025",
        Time: "Morning 9 to 2",
        location: "123, Street Name, Landmark, City"
    },
    {
        id: "2RTO782U13",
        categories: "Plumbing",
        subcategories: "Pipe Installation",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        Date: "05/01/2025",
        Time: "Morning 9 to 2",
        location: "123, Street Name, Landmark, City"
    },
]